import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var WarningCircleFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 .42c-12.2 0-22 9.8-22 22s9.8 22 22 22 22-9.8 22-22-9.8-22-22-22Zm0 35.5c-1.2 0-2.2-1-2.2-2.2 0-1.2 1-2.2 2.2-2.2 1.2 0 2.2 1 2.2 2.2 0 1.2-1 2.2-2.2 2.2Zm-1.2-25.8c0-.7.6-1.2 1.2-1.2s1.2.5 1.2 1.2v17.6c0 .7-.6 1.2-1.2 1.2s-1.2-.5-1.2-1.2v-17.6Z"
  }));
});
WarningCircleFill.displayName = 'WarningCircleFill';
WarningCircleFill.defaultProps = {
  'aria-label': 'WarningCircleFill'
};
export default WarningCircleFill;